/**
 * Olympia Product Page JavaScript
 * Swiper, thumbnails, variant selection, add to cart, buy now, wishlist, cart count
 */

(function() {
  'use strict';

  if (!document.querySelector('.olympia-product')) {
    return;
  }

  let productSwiper = null;
  let productData = null;

  function init() {
    try { fetch('http://127.0.0.1:7580/ingest/c34222cc-8364-4c60-90fd-50fe23861043',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'5e023e'},body:JSON.stringify({sessionId:'5e023e',location:'init',message:'init',data:{},timestamp:Date.now(),hypothesisId:'C'})}).catch(function(){}); } catch(e) {}
    if (typeof window.Shopify !== 'undefined' && window.Shopify.routes) {
      fetchProductData();
    }
    moveOverflowSlidesIfMobile();
    initSwiper();
    initGalleryZoom();
    initThumbnails();
    initVariantSelector();
    initVariantValidation();
    initCartCount();
    initBuyItNow();
    initWishlist();
    loadWishlistState();
    updateHeaderCartCount();
  }

  function fetchProductData() {
    const productForm = document.getElementById('olympia-product-form');
    if (!productForm) return;
    const urlParts = window.location.pathname.split('/');
    const productHandle = urlParts[urlParts.length - 1];
    fetch('/products/' + productHandle + '.js')
      .then(response => response.json())
      .then(product => {
        productData = product;
        checkVariantSelection();
      })
      .catch(() => {});
  }

  function moveOverflowSlidesIfMobile() {
    const root = document.querySelector('.olympia-product');
    if (!root) return;
    const isMobile = window.matchMedia
      ? window.matchMedia('(max-width: 989px)').matches
      : (window.innerWidth < 990);
    if (!isMobile) return;

    const swiperContainer = root.querySelector('[data-product-swiper]');
    const overflow = root.querySelector('[data-overflow-media]');
    if (!swiperContainer || !overflow) return;

    const wrapper = swiperContainer.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    const slides = Array.from(wrapper.children).filter(el => el.classList.contains('swiper-slide'));
    if (slides.length <= 2) return;

    for (let i = 2; i < slides.length; i++) {
      const slide = slides[i];
      const img = slide.querySelector('img');
      if (img) {
        const item = document.createElement('div');
        item.className = 'olympia-product__overflow-media-item';
        item.appendChild(img);
        overflow.appendChild(item);
      }
      slide.remove();
    }

    const total = root.querySelector('.olympia-product__gallery-total');
    if (total) total.textContent = '2';
  }

  function initSwiper() {
    try { fetch('http://127.0.0.1:7580/ingest/c34222cc-8364-4c60-90fd-50fe23861043',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'5e023e'},body:JSON.stringify({sessionId:'5e023e',location:'initSwiper',message:'entry',data:{w:window.innerWidth,d:window.innerWidth>=990,s:typeof Swiper!=='undefined'},timestamp:Date.now(),hypothesisId:'A,E'})}).catch(function(){}); } catch(e) {}
    const root = document.querySelector('.olympia-product');
    if (!root) return;
    const swiperContainer = root.querySelector('[data-product-swiper]');
    if (!swiperContainer) return;
    const slides = swiperContainer.querySelectorAll('.swiper-slide');
    if (slides.length < 2) return;

    const mediaWrap = root.querySelector('.olympia-product__media');
    const isDesktop = window.matchMedia ? window.matchMedia('(min-width: 990px)').matches : (window.innerWidth >= 990);
    if (isDesktop && mediaWrap) {
      try { fetch('http://127.0.0.1:7580/ingest/c34222cc-8364-4c60-90fd-50fe23861043',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'5e023e'},body:JSON.stringify({sessionId:'5e023e',location:'initSwiper',message:'desktop stack',data:{},timestamp:Date.now(),hypothesisId:'A'})}).catch(function(){}); } catch(e) {}
      mediaWrap.classList.add('olympia-product__media--stack');
      return;
    }

    if (typeof Swiper === 'undefined') {
      setTimeout(initSwiper, 150);
      return;
    }
    const prevBtn = root.querySelector('.olympia-product__gallery-nav-btn--prev');
    const nextBtn = root.querySelector('.olympia-product__gallery-nav-btn--next');
    const scrollbarWrap = root.querySelector('.olympia-product__scrollbar-wrap');
    const scrollbarEl = scrollbarWrap ? scrollbarWrap.querySelector('.swiper-scrollbar') : null;

    const swiperOptions = {
      slidesPerView: 1,
      loop: false,
      speed: 250,
      allowTouchMove: true,
      navigation: false,
      on: {
        init: function() {
          updateGalleryCounter(1, this.slides.length);
        },
        slideChange: function() {
          updateGalleryCounter(this.activeIndex + 1, this.slides.length);
        }
      }
    };
    if (scrollbarEl) {
      swiperOptions.scrollbar = { el: scrollbarEl, draggable: true, hide: false };
    }
    productSwiper = new Swiper(swiperContainer, swiperOptions);
    swiperContainer._olympiaSwiper = productSwiper;
    try { fetch('http://127.0.0.1:7580/ingest/c34222cc-8364-4c60-90fd-50fe23861043',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'5e023e'},body:JSON.stringify({sessionId:'5e023e',location:'initSwiper',message:'swiper created',data:{},timestamp:Date.now(),hypothesisId:'E'})}).catch(function(){}); } catch(e) {}
    initGalleryNav();

    requestAnimationFrame(() => {
      if (productSwiper) productSwiper.update();
    });
    const images = swiperContainer.querySelectorAll('img');
    let imagesToLoad = images.length;
    if (imagesToLoad === 0) {
      if (productSwiper) productSwiper.update();
    } else {
      images.forEach(img => {
        if (img.complete) imagesToLoad--;
        else {
          img.addEventListener('load', () => {
            imagesToLoad--;
            if (imagesToLoad === 0 && productSwiper) productSwiper.update();
          });
          img.addEventListener('error', () => {
            imagesToLoad--;
            if (imagesToLoad === 0 && productSwiper) productSwiper.update();
          });
        }
      });
      if (imagesToLoad === 0 && productSwiper) productSwiper.update();
    }
  }

  function updateGalleryCounter(current, total) {
    const currentEl = document.querySelector('.olympia-product__gallery-current');
    const totalEl = document.querySelector('.olympia-product__gallery-total');
    if (currentEl) currentEl.textContent = String(current);
    if (totalEl) totalEl.textContent = String(total);
  }

  function initGalleryNav() {
    const root = document.querySelector('.olympia-product');
    if (!root) return;
    const prevBtn = root.querySelector('.olympia-product__gallery-nav-btn--prev');
    const nextBtn = root.querySelector('.olympia-product__gallery-nav-btn--next');
    const container = root.querySelector('[data-product-swiper]');
    try { fetch('http://127.0.0.1:7580/ingest/c34222cc-8364-4c60-90fd-50fe23861043',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'5e023e'},body:JSON.stringify({sessionId:'5e023e',location:'initGalleryNav',message:'nav',data:{c:!!container,s:!!(container&&container._olympiaSwiper)},timestamp:Date.now(),hypothesisId:'F'})}).catch(function(){}); } catch(e) {}
    if (!prevBtn && !nextBtn) return;
    if (!container || !container._olympiaSwiper) return;

    var touchHandled = false;
    function goPrev(e) {
      e.preventDefault();
      e.stopPropagation();
      if (container._olympiaSwiper) container._olympiaSwiper.slidePrev();
    }
    function goNext(e) {
      e.preventDefault();
      e.stopPropagation();
      // #region agent log
      fetch('http://127.0.0.1:7580/ingest/c34222cc-8364-4c60-90fd-50fe23861043',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'5e023e'},body:JSON.stringify({sessionId:'5e023e',location:'olympia-product.js:goNext',message:'goNext',data:{hasSwiper:!!(container&&container._olympiaSwiper)},timestamp:Date.now(),hypothesisId:'F'})}).catch(function(){});
      // #endregion
      if (container._olympiaSwiper) container._olympiaSwiper.slideNext();
    }

    prevBtn.addEventListener('touchstart', function(e) {
      e.preventDefault();
    }, { passive: false });
    prevBtn.addEventListener('touchend', function(e) {
      e.preventDefault();
      touchHandled = true;
      setTimeout(function() { touchHandled = false; }, 400);
      goPrev(e);
    }, { passive: false });
    prevBtn.addEventListener('click', function(e) {
      if (touchHandled) { e.preventDefault(); return; }
      goPrev(e);
    });

    nextBtn.addEventListener('touchstart', function(e) {
      e.preventDefault();
    }, { passive: false });
    nextBtn.addEventListener('touchend', function(e) {
      e.preventDefault();
      touchHandled = true;
      setTimeout(function() { touchHandled = false; }, 400);
      goNext(e);
    }, { passive: false });
    nextBtn.addEventListener('click', function(e) {
      if (touchHandled) { e.preventDefault(); return; }
      goNext(e);
    });
  }

  function initGalleryZoom() {
    const zoomBtn = document.querySelector('.olympia-product__gallery-zoom--mobile');
    if (!zoomBtn) return;
    zoomBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const root = document.querySelector('.olympia-product');
      if (!root) return;
      let imgSrc = '';
      const activeImg = root.querySelector('.swiper-slide-active img');
      const firstSlideImg = root.querySelector('[data-product-swiper] .swiper-slide img');
      const singleImg = root.querySelector('.olympia-product__main-image--single img');
      if (activeImg) {
        imgSrc = activeImg.currentSrc || activeImg.src;
      }
      if (!imgSrc && firstSlideImg) {
        imgSrc = firstSlideImg.currentSrc || firstSlideImg.src;
      }
      if (!imgSrc && singleImg) {
        imgSrc = singleImg.currentSrc || singleImg.src;
      }
      if (!imgSrc) return;
      const overlay = document.createElement('div');
      overlay.className = 'olympia-product__zoom-overlay';
      overlay.innerHTML = '<button type="button" class="olympia-product__zoom-close" aria-label="Close">&times;</button><div class="olympia-product__zoom-inner"><img src="" alt="Zoom" /></div>';
      const imgEl = overlay.querySelector('img');
      imgEl.src = imgSrc;
      overlay.querySelector('.olympia-product__zoom-close').onclick = function() {
        overlay.remove();
        document.body.style.overflow = '';
      };
      overlay.onclick = function(ev) {
        if (ev.target === overlay) {
          overlay.remove();
          document.body.style.overflow = '';
        }
      };
      overlay.querySelector('.olympia-product__zoom-inner').onclick = function(ev) { ev.stopPropagation(); };
      document.body.style.overflow = 'hidden';
      document.body.appendChild(overlay);
    });
  }

  function initThumbnails() {
    const thumbnails = document.querySelectorAll('.olympia-product__thumbnail');
    if (thumbnails.length === 0) return;
    thumbnails.forEach(function(thumb, index) {
      thumb.addEventListener('click', function() {
        thumbnails.forEach(function(t) { t.classList.remove('olympia-product__thumbnail--active'); });
        this.classList.add('olympia-product__thumbnail--active');
        if (productSwiper) productSwiper.slideTo(index);
      });
    });
  }

  function initVariantSelector() {
    const variantSelects = document.querySelectorAll('.olympia-product__variant-select');
    const hiddenVariantSelect = document.getElementById('olympia-variant-select');
    if (!hiddenVariantSelect || variantSelects.length === 0) return;
    function updatePillActiveState(select) {
      const variantBlock = select.closest('.olympia-product__variant');
      if (!variantBlock) return;
      const pills = variantBlock.querySelectorAll('.olympia-product__variant-pill');
      const value = select.value || '';
      pills.forEach(function(pill) {
        const isActive = pill.getAttribute('data-value') === value;
        pill.classList.toggle('olympia-product__variant-pill--active', isActive);
        pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }
    variantSelects.forEach(function(select) {
      select.addEventListener('change', function() {
        updateVariantSelection();
        checkVariantSelection();
        updatePillActiveState(select);
      });
    });
    hiddenVariantSelect.addEventListener('change', function() { checkVariantSelection(); });
    document.querySelectorAll('.olympia-product__variant-pill').forEach(function(pill) {
      pill.addEventListener('click', function() {
        const variantBlock = this.closest('.olympia-product__variant');
        const select = variantBlock && variantBlock.querySelector('.olympia-product__variant-select');
        if (!select) return;
        const value = this.getAttribute('data-value') || '';
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        updatePillActiveState(select);
      });
    });
    variantSelects.forEach(updatePillActiveState);
  }

  function initFormPrevention() {
    const form = document.getElementById('olympia-product-form') || document.querySelector('.olympia-product form[action*="/cart/add"]');
    if (!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    }, true);
    form.onsubmit = function(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };
  }

  function initVariantValidation() {
    initFormPrevention();
    const addToBagBtn = document.getElementById('olympia-add-to-bag') || document.querySelector('[data-olympia-atc]');
    const productForm = document.getElementById('olympia-product-form') || document.querySelector('.olympia-product form[action*="/cart/add"]');
    if (!addToBagBtn || !productForm) return;
    checkVariantSelection();

    addToBagBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (!isVariantSelected()) {
        showVariantError('Please choose the variants first.');
        return false;
      }
      const hiddenVariantSelect = document.getElementById('olympia-variant-select');
      if (!hiddenVariantSelect || !hiddenVariantSelect.value) {
        showVariantError('Please choose the variants first.');
        return false;
      }
      const variantId = hiddenVariantSelect.value;
      addToBagBtn.disabled = true;
      const originalText = addToBagBtn.textContent;
      addToBagBtn.textContent = 'ADDING...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(response => {
          if (!response.ok) return response.json().then(err => Promise.reject(err));
          return response.json();
        })
        .then(item => {
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: item } }));
          openCartDrawer();
          addToBagBtn.disabled = false;
          addToBagBtn.textContent = originalText;
          hideVariantError();
        })
        .catch(error => {
          const errorMsg = error.description || error.message || 'Unable to add product to cart. Please try again.';
          showVariantError(errorMsg);
          addToBagBtn.disabled = false;
          addToBagBtn.textContent = originalText;
        });
      return false;
    }, true);

    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    }, true);
  }

  function initBuyItNow() {
    const buyNowBtn = document.getElementById('olympia-buy-now');
    if (!buyNowBtn) return;
    buyNowBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!isVariantSelected()) {
        showVariantError('Please choose the variants first.');
        return;
      }
      const hiddenVariantSelect = document.getElementById('olympia-variant-select');
      if (!hiddenVariantSelect || !hiddenVariantSelect.value) {
        showVariantError('Please choose the variants first.');
        return;
      }
      const variantId = hiddenVariantSelect.value;
      buyNowBtn.disabled = true;
      buyNowBtn.textContent = 'ADDING...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(response => {
          if (!response.ok) return response.json().then(err => Promise.reject(err));
          return response.json();
        })
        .then(() => { window.location.href = '/checkout'; })
        .catch(error => {
          const errorMsg = error.description || error.message || 'Unable to add product to cart. Please try again.';
          showVariantError(errorMsg);
          buyNowBtn.disabled = false;
          buyNowBtn.textContent = 'BUY IT NOW';
        });
    });
  }

  function isVariantSelected() {
    const variantSelects = document.querySelectorAll('.olympia-product__variant-select');
    if (variantSelects.length === 0) return true;
    const hiddenVariantSelect = document.getElementById('olympia-variant-select');
    if (!hiddenVariantSelect) return false;
    let allSelected = true;
    variantSelects.forEach(function(select) {
      if (!select.value || select.value === '' || select.value.includes('[Required]')) allSelected = false;
    });
    if (!hiddenVariantSelect.value) return false;
    return allSelected;
  }

  function checkVariantSelection() {
    const addToBagBtn = document.getElementById('olympia-add-to-bag');
    const buyNowBtn = document.getElementById('olympia-buy-now');
    const variantError = document.getElementById('olympia-variant-error');
    const hasVariants = document.querySelectorAll('.olympia-product__variant-select').length > 0;
    const variantSelected = isVariantSelected();
    const hiddenVariantSelect = document.getElementById('olympia-variant-select');
    const variantId = hiddenVariantSelect ? hiddenVariantSelect.value : null;
    let variantAvailable = true;
    if (productData && variantId) {
      const variant = productData.variants.find(v => v.id.toString() === variantId.toString());
      if (variant) variantAvailable = variant.available;
    }
    if (hasVariants) {
      if (variantSelected && variantAvailable) {
        if (addToBagBtn) { addToBagBtn.disabled = false; addToBagBtn.classList.remove('olympia-product__button--disabled'); }
        if (buyNowBtn) { buyNowBtn.disabled = false; buyNowBtn.classList.remove('olympia-product__button--disabled'); }
        if (variantError) variantError.style.display = 'none';
      } else {
        if (addToBagBtn) { addToBagBtn.disabled = true; addToBagBtn.classList.add('olympia-product__button--disabled'); }
        if (buyNowBtn) { buyNowBtn.disabled = true; buyNowBtn.classList.add('olympia-product__button--disabled'); }
      }
    } else {
      if (addToBagBtn) addToBagBtn.disabled = !variantAvailable;
      if (buyNowBtn) buyNowBtn.disabled = !variantAvailable;
    }
  }

  function showVariantError(message) {
    const variantError = document.getElementById('olympia-variant-error');
    if (variantError) {
      variantError.textContent = message || 'Please choose the variants first.';
      variantError.style.display = 'block';
      variantError.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function hideVariantError() {
    const variantError = document.getElementById('olympia-variant-error');
    if (variantError) variantError.style.display = 'none';
  }

  function updateVariantSelection() {
    const variantSelects = document.querySelectorAll('.olympia-product__variant-select');
    const hiddenVariantSelect = document.getElementById('olympia-variant-select');
    if (!hiddenVariantSelect) return;
    const selectedOptions = [ '', '', '' ];
    variantSelects.forEach(function(select) {
      const idx = parseInt(select.getAttribute('data-option-index'), 10);
      if (!isNaN(idx) && idx >= 0 && idx <= 2) selectedOptions[idx] = select.value || '';
    });
    const variantOptions = hiddenVariantSelect.querySelectorAll('option');
    for (let i = 0; i < variantOptions.length; i++) {
      const option = variantOptions[i];
      const opt1 = option.getAttribute('data-option1') || '';
      const opt2 = option.getAttribute('data-option2') || '';
      const opt3 = option.getAttribute('data-option3') || '';
      const variantOpts = [ opt1, opt2, opt3 ];
      let match = true;
      let hasSelection = false;
      for (let j = 0; j <= 2; j++) {
        const sel = selectedOptions[j];
        if (sel) hasSelection = true;
        if (sel) {
          const vOpt = (variantOpts[j] || '').toLowerCase();
          if (vOpt !== sel.toLowerCase()) { match = false; break; }
        }
      }
      if (match && hasSelection) {
        hiddenVariantSelect.value = option.value;
        hiddenVariantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        break;
      }
    }
  }

  function updateProductPageCartCount() {
    const cartCountEl = document.querySelector('.olympia-product [data-cart-count]');
    if (!cartCountEl) return;
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const count = cart.item_count || 0;
        cartCountEl.textContent = count + ' (' + count + ' item' + (count !== 1 ? 's' : '') + ')';
      })
      .catch(() => {});
  }

  function updateHeaderCartCount() {
    if (typeof window.updateFreedomCartCount === 'function') {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => { window.updateFreedomCartCount(cart.item_count || 0); })
        .catch(() => {});
    } else {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const count = cart.item_count || 0;
          document.querySelectorAll('[data-freedom-cart-count]').forEach(el => {
            if (count > 0) { el.textContent = String(count); el.style.display = 'inline-block'; }
            else el.style.display = 'none';
          });
        })
        .catch(() => {});
    }
  }

  function openCartDrawer() {
    const cartDrawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    if (typeof cartDrawer.renderContents === 'function') {
      fetch('/?section_id=cart-drawer')
        .then(response => response.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const cartDrawerHTML = doc.querySelector('cart-drawer') || doc.querySelector('#cart-drawer');
          if (cartDrawerHTML) {
            const sections = {
              'cart-drawer': (cartDrawerHTML.querySelector('.cart-drawer') && cartDrawerHTML.querySelector('.cart-drawer').innerHTML) || '',
              'cart-icon-bubble': (cartDrawerHTML.querySelector('#cart-icon-bubble') && cartDrawerHTML.querySelector('#cart-icon-bubble').innerHTML) || ''
            };
            cartDrawer.renderContents({ sections: sections });
          } else if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        })
        .catch(() => { if (typeof cartDrawer.open === 'function') cartDrawer.open(); });
    } else if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }

  function initCartCount() {
    document.addEventListener('cart:updated', function() {
      updateHeaderCartCount();
      updateProductPageCartCount();
    });
    updateHeaderCartCount();
    updateProductPageCartCount();
  }

  function initWishlist() {
    const wishlistBtn = document.getElementById('olympia-wishlist-btn') || document.querySelector('.olympia-product [data-wishlist]');
    if (!wishlistBtn) return;
    wishlistBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const productHandle = this.getAttribute('data-product-handle');
      if (!productHandle) return;
      const isLoggedIn = window.FREEDOM_CUSTOMER_LOGGED_IN === true ||
        document.body.classList.contains('customer-logged-in') ||
        document.querySelector('[data-customer-logged-in]');
      if (!isLoggedIn) {
        window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.href);
        return;
      }
      toggleWishlist(productHandle, wishlistBtn);
    });
  }

  function toggleWishlist(productHandle, button) {
    let wishlist = getWishlist();
    const index = wishlist.indexOf(productHandle);
    if (index > -1) {
      wishlist.splice(index, 1);
      button.classList.remove('olympia-product__wishlist--active');
      var path = button.querySelector('svg path');
      if (path) path.setAttribute('fill', 'none');
      showToast('Removed from wishlist');
    } else {
      wishlist.push(productHandle);
      button.classList.add('olympia-product__wishlist--active');
      var path = button.querySelector('svg path');
      if (path) path.setAttribute('fill', 'currentColor');
      showToast('Saved for later');
    }
    saveWishlist(wishlist);
  }

  function getWishlist() {
    try {
      const stored = localStorage.getItem('olympia_wishlist');
      return stored ? JSON.parse(stored) : [];
    } catch (e) { return []; }
  }

  function saveWishlist(wishlist) {
    try { localStorage.setItem('olympia_wishlist', JSON.stringify(wishlist)); } catch (e) {}
  }

  function loadWishlistState() {
    const wishlistBtn = document.getElementById('olympia-wishlist-btn') || document.querySelector('.olympia-product [data-wishlist]');
    if (!wishlistBtn) return;
    const productHandle = wishlistBtn.getAttribute('data-product-handle');
    if (!productHandle) return;
    const wishlist = getWishlist();
    if (wishlist.indexOf(productHandle) > -1) {
      wishlistBtn.classList.add('olympia-product__wishlist--active');
      var path = wishlistBtn.querySelector('svg path');
      if (path) path.setAttribute('fill', 'currentColor');
    }
  }

  function showToast(message) {
    var existing = document.querySelector('.olympia-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'olympia-toast';
    toast.textContent = message;
    toast.style.cssText = 'position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%); background: #000; color: #fff; padding: 12px 24px; border-radius: 4px; z-index: 10000; font-family: Pretendard, Arial, sans-serif; font-size: 14px;';
    document.body.appendChild(toast);
    setTimeout(function() {
      toast.style.opacity = '0';
      toast.style.transition = 'opacity 0.3s';
      setTimeout(function() { toast.remove(); }, 300);
    }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var el = document.querySelector('[data-section-id="' + event.detail.sectionId + '"]');
    if (el && el.classList.contains('olympia-product')) {
      if (productSwiper) {
        productSwiper.destroy(true, true);
        productSwiper = null;
      }
      init();
    }
  });
})();
